// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';
import uuidv4 from 'uuid/v4';

import statusOk from '../../../../images/status-ok.png';
import styles from './styles';

class OrderData extends React.Component {
  state = {};

  render() {
    const {
      classes,
      payment,
      price,
      orderId,
    } = this.props;
    const data = [{
      name: 'Order ID:',
      value: orderId,
      style: classNames(classes.mainInfoSubContainer, classes.toStart),
    }, {
      name: 'Order Value:',
      value: `£${price.toFixed(2) || price}`,
      style: classes.mainInfoSubContainer,
    }, {
      name: 'Payment Method:',
      value: payment.toUpperCase(),
      style: classNames(classes.mainInfoSubContainer, classes.toEnd),
    }];
    return (
      <div className={classes.mainContainer}>
        <div className={classes.mainInfoContainer}>
          {data.map(el => (
            <span key={uuidv4()} className={el.style}>
              <img className={classes.imageOk} src={statusOk} alt={el.name} />
              <span>{el.name}</span>
              <span className={classes.fontBold}>{el.value}</span>
            </span>))}
        </div>
      </div>
    );
  }
}

OrderData.propTypes = {
  classes: PropTypes.object,
  payment: PropTypes.string,
  price: PropTypes.any,
  orderId: PropTypes.number,
};

OrderData.defaultProps = {
  classes: {},
  payment: 'No payment',
  price: 0,
  orderId: 0,
};

export default withStyles(styles)(OrderData);
